import { isMobile } from "react-device-detect";

export const getDeviceIsMobile = () => isMobile;
